import { render, staticRenderFns } from "./FccTabelaBotao.vue?vue&type=template&id=5d869e36"
import script from "./FccTabelaBotao.vue?vue&type=script&lang=js"
export * from "./FccTabelaBotao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports